<template>
    <div :class="[!bgColor ? 'bg-white' : '']" 
         :style="[bgColor ? `background-color: ${bgColor}` : '', 
                 `padding-top: ${topPadding}px;padding-bottom: ${bottomPadding}px;`]">
        <Container class="px-[18px]">
            <div class="grid" :style="`gap: ${gap}px`" 
                 :class="`grid-cols-1 md:grid-cols-2 lg:grid-cols-${columnsCount}`">
                <template v-for="(item, index) in items" :key="index">
                    <div v-if="!item.isEmpty" 
                         :class="[
                             `col-span-1 md:col-span-${item.colspan}`,
                             item.padding ? `p-${item.padding}` : ''
                         ]"
                         :style="`height: ${item.height}px`">
                        <div class="h-full w-full" 
                             :class="[
                                 `flex justify-${item.horizontalAlign} items-${item.verticalAlign}`,
                                 item.padding ? `p-${item.padding}` : ''
                             ]">
                            <!-- Image Content -->
                            <template v-if="item.type === 'image'">
                                <a v-if="item.link" :href="item.link" target="_blank" 
                                   class="block" :style="`width: ${item.width}px`">
                                    <img :src="item.image" 
                                         :alt="item.alt"
                                         class="w-full h-auto"
                                         :style="item.height ? `height: ${item.height}px; object-fit: cover;` : ''" />
                                </a>
                                <img v-else 
                                     :src="item.image" 
                                     :alt="item.alt"
                                     class="block"
                                     :style="`
                                         width: ${item.width}px; 
                                         ${item.height ? `height: ${item.height}px; object-fit: cover;` : ''}
                                     `" />
                            </template>
                            
                            <!-- Text Content -->
                            <template v-else-if="item.type === 'text'">
                                <div :class="`text-${item.textAlign}`"
                                     :style="`
                                         ${item.fontSize ? `font-size: ${item.fontSize}px;` : ''}
                                         ${item.textColor ? `color: ${item.textColor};` : ''}
                                     `">
                                    <div v-html="item.content"></div>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
        </Container>
    </div>
</template>

<script>
import Container from '../../../Layouts/Container.vue'

export default {
    components: {
        Container
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        bgColor: {
            type: String,
            default: null
        },
        topPadding: {
            type: Number,
            default: 50
        },
        bottomPadding: {
            type: Number,
            default: 50
        },
        columnsCount: {
            type: Number,
            default: 4
        },
        gap: {
            type: Number,
            default: 16
        }
    }
}
</script> 